import React from 'react';
import { Helmet } from 'react-helmet';
import './user-details.scss';
import '../../../css/design-system.scss';

export default function UserGuideModern(props) {
  return (
    <div className="settings-modern-page">
      <Helmet>
        <title>Neurochecklists | User Guide</title>
      </Helmet>

      <div className="settings-form-wrap" style={{ maxWidth: '680px' }}>
        <div className="settings-page-header">
          <h1 className="section-title">User Guide</h1>
          <p className="section-sub">Everything you need to know to get the most from Neurochecklists.</p>
        </div>

        <div className="settings-card">
          <div className="settings-meta-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <span className="meta-label" style={{ marginBottom: '12px' }}>Structure</span>
            <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>The database consists of subspecialty categories</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Each category is made up of chapters</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Each chapter is made up of topics</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Each topic consists of the checklists</li>
            </ul>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-meta-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <span className="meta-label" style={{ marginBottom: '12px' }}>Exploration</span>
            <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Explore by search boxes available on all pages</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Explore the index for chapters or by clicking on the &lsquo;explore&rsquo; tab</li>
            </ul>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-meta-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <span className="meta-label" style={{ marginBottom: '12px' }}>Contents</span>
            <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>History</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Clinical examination</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Investigations</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Treatment</li>
            </ul>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-meta-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <span className="meta-label" style={{ marginBottom: '12px' }}>References</span>
            <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>All checklists have a reference section</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>The references are sourced from standard neurological texts and journals</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>The most important references are shown with the checklist title</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Clicking on the reference number in the text takes you to the reference citation</li>
              <li style={{ fontSize: '14px', color: 'var(--body)' }}>Clicking on the reference will open the PubMed abstract of the reference</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
